import React, { useState, useRef } from 'react'
import {
  Box,
  HStack,
  Text,
  IconButton,
  Input,
  useOutsideClick,
} from '@chakra-ui/react'
import { Edit2, Trash2, Check, X } from 'lucide-react'
import { IPAddress } from '@hz/stealthy-gmc-cloaker-common/api-types/whitelist'
interface IPTagProps {
  ip: {
    ipId: string
    ipAddress: string
    tag?: string
    addedBy?: string;
    userId?: string;
  }
  myUserId: string | null;
  onDelete: () => void
  handleEdit: (params: Pick<IPAddress, 'ipId' | 'ipAddress' | 'tag'>) => void;
}
export const IPTag = ({ ip, onDelete, handleEdit, myUserId }: IPTagProps) => {
  const [isEditing, setIsEditing] = useState(false)
  const [editedAddress, setEditedAddress] = useState(ip.ipAddress)
  const [editedLabel, setEditedLabel] = useState(ip.tag || '')
   
  
  const ref = useRef<HTMLDivElement>(null)
  useOutsideClick({
    ref: ref,
    handler: () => setIsEditing(false),
  })
  const handleSave = () => {
    if (editedAddress.trim()) {
      handleEdit({
        ipId: ip.ipId,
        ipAddress: editedAddress,
        tag: editedLabel || undefined,
      }
        
      )
      setIsEditing(false)
    }
  }

  if (isEditing) {
    return (
      <Box
        ref={ref}
        bg="gray.700"
        p={2}
        borderRadius="md"
        borderWidth={1}
        borderColor="blue.500"
      >
        <HStack spacing={2}>
          <Input
            value={editedAddress}
            onChange={(e) => setEditedAddress(e.target.value)}
            size="sm"
            variant="unstyled"
            color="white"
            placeholder="IP Address"
            px={2}
          />
          <Input
            value={editedLabel}
            onChange={(e) => setEditedLabel(e.target.value)}
            size="sm"
            variant="unstyled"
            color="gray.300"
            placeholder="Label (optional)"
            px={2}
          />
          <IconButton
            icon={<Check size={16} />}
            aria-label="Save"
            size="sm"
            variant="ghost"
            color="green.400"
            onClick={handleSave}
            _hover={{
              bg: 'whiteAlpha.100',
            }}
          />
          <IconButton
            icon={<X size={16} />}
            aria-label="Cancel"
            size="sm"
            variant="ghost"
            color="gray.400"
            onClick={() => setIsEditing(false)}
            _hover={{
              bg: 'whiteAlpha.100',
            }}
          />
        </HStack>
      </Box>
    )
  }
  return (
    <Box
      bg="gray.700"
      px={4}
      py={2}
      borderRadius="md"
      position="relative"
      role="group"
    >
      <HStack spacing={2} justify="space-between">
        <HStack spacing={2}>
          <Text color="white" fontFamily="mono">
            {ip.ipAddress}
          </Text>
          {ip.tag && (
            <Text color="gray.400" fontSize="sm">
              ({ip.tag})
            </Text>
          )}
          {ip.addedBy && (
             <Text color="gray.500" fontSize="xs">
             added by {ip.userId === myUserId ? 'You' :  ip.addedBy}
           </Text>
          )}
        </HStack>
        <HStack
          spacing={1}
          opacity={0}
          _groupHover={{
            opacity: 1,
          }}
          transition="opacity 0.2s"
        >
          <IconButton
            icon={<Edit2 size={14} />}
            aria-label="Edit IP"
            size="sm"
            variant="ghost"
            color="gray.400"
            onClick={() => setIsEditing(true)}
            _hover={{
              color: 'white',
              bg: 'whiteAlpha.100',
            }}
          />
          <IconButton
            icon={<Trash2 size={14} />}
            aria-label="Remove IP"
            size="sm"
            variant="ghost"
            color="red.400"
            onClick={onDelete}
            _hover={{
              bg: 'whiteAlpha.100',
            }}
          />
        </HStack>
      </HStack>
    </Box>
  )
}
